import { createStore } from "vuex";
import { QuestionOption, QuestionOptionNO, Portraitn } from "@/model/tanabata/TanabataModel";

export default createStore({
  state: {
    question: {
      one: "",
      two: "",
      three: "",
      four: "",
      five: "",
    },
    portrait: {
      id: 0,
      name: "",
      character: "",
      characterDesc: "",
      imgURL: "",
      characterImgURL: "",
      Portraitn: "",
      resultUrl: "",
      redirectURL: "",
      shopItemID: 0
    }
  },
  mutations: {
    setQuestion(state, v: QuestionOption) {
      if (v.option === QuestionOptionNO.questionOptionOne) {
        state.question.one = v.value;
      } else if (v.option === QuestionOptionNO.questionOptionTwo) {
        state.question.two = v.value;
      } else if (v.option === QuestionOptionNO.questionOptionThree) {
        state.question.three = v.value;
      } else if (v.option === QuestionOptionNO.questionOptionFour) {
        state.question.four = v.value;
      } else if (v.option === QuestionOptionNO.questionOptionFive) {
        state.question.five = v.value;
      }
    },
    setpPortraitn(state, v: Portraitn) {
      state.portrait.id = v.id;
      state.portrait.name = v.name;
      state.portrait.imgURL = v.imgURL;
      state.portrait.character = v.character;
      state.portrait.characterDesc = v.characterDesc;
      state.portrait.characterImgURL = v.characterImgURL;
      state.portrait.resultUrl = v.resultUrl;
      state.portrait.redirectURL = v.redirectURL;
      state.portrait.shopItemID = v.shopItemID;
    },
  },
  actions: {},
  modules: {},
});
